import voucher from './voucher';

const rwdChild = [
    // To be determine if it is on admin or partner profile
    // channel,
    voucher
];

export default rwdChild;
